export class PasswordConfirmModel {

    public sessionId: string;
    public code: string;

    public newPassword: string;
    public newPasswordConfirmation: string;
   
}


// WEBPACK FOOTER //
// ./src/app/core/models/passwordConfirm.model.ts